import React, { useState } from 'react';
import { useAppData } from '../AppContext';
import './Resources.css';

const TABS = [
  { id: 'bridges',  label: 'Bridges' },
  { id: 'food',     label: 'Food & Beverage' },
  { id: 'casestudy',label: 'Application Case Study' },
  { id: 'railways', label: 'Zinga on Railways' },
];

const CASE_STUDIES = [
  {
    title: 'Mumbai Trans Harbour Link — Tata Projects & Daewoo JV',
    desc: 'ZINGA applications done for temporary bridge steel structures of Mumbai Trans Harbour Link Project.',
    imgs: [
      'https://static.wixstatic.com/media/4c89a3_c288d061bcae41e2828a76dc0700f7fd~mv2.jpg/v1/fill/w_400,h_300,al_c,q_80,enc_avif,quality_auto/MTHL-Temporary-Bridge-Structures-1.jpg',
      'https://static.wixstatic.com/media/4c89a3_2b03e6d9b5af434bac3e1b85dbb972c5~mv2.jpg/v1/fill/w_400,h_300,al_c,q_80,enc_avif,quality_auto/MTHL-Temporary-Bridge-Structures-3.jpg',
    ],
  },
  {
    title: 'MMRDA FOB on Western Express Highway',
    desc: 'ZINGA applications done for maintenance painting of MMRDA 8 nos. FOB\'s on Western Express Highway from Jogeshwari to Dahisar.',
    imgs: [
      'https://static.wixstatic.com/media/4c89a3_b36809aeb1e04fbc96d7ad0a38d36336~mv2.jpg/v1/fill/w_400,h_430,al_c,q_80,enc_avif,quality_auto/11.jpg',
      'https://static.wixstatic.com/media/4c89a3_07cab3937652491f9962e6fc6ba3ada1~mv2.jpg/v1/fill/w_400,h_430,al_c,q_80,enc_avif,quality_auto/33.jpg',
    ],
  },
  {
    title: 'Central Railway — Kamanwadi Bridge',
    desc: 'ZINGA applications done for Kamanwadi Bridge (Central Railway) between Panvel – Diwa route.',
    imgs: [
      'https://static.wixstatic.com/media/4c89a3_7647bac257384b2b8701ac23989fe9ca~mv2.jpg/v1/fill/w_500,h_300,al_c,q_80,enc_avif,quality_auto/CR-Kamanwadi-Bridge%2C-After-Zinga-Applica.jpg',
      'https://static.wixstatic.com/media/4c89a3_c94660ac7510471aa1681a51d9126e87~mv2.jpg/v1/fill/w_500,h_300,al_c,q_80,enc_avif,quality_auto/CR-Kamanwadi-Bridge%2C-Before-Zinga-Applic.jpg',
    ],
  },
  {
    title: 'Wankhede Stadium & D.Y. Patil Stadium',
    desc: 'ZINGA applications done for Wankhede Stadium – Mumbai & D.Y. Patil Stadium – Navi Mumbai. (Trusses)',
    imgs: [
      'https://static.wixstatic.com/media/4c89a3_61bc1c76afb34c2ca1ba28559d91c7a5~mv2.jpg/v1/fill/w_400,h_460,al_c,q_80,enc_avif,quality_auto/Wankhede-Stadium%2C-Mumbai-3.jpg',
      'https://static.wixstatic.com/media/4c89a3_1ef19932240c4d84baeb4f30c25fc4d2~mv2.jpg/v1/fill/w_400,h_460,al_c,q_80,enc_avif,quality_auto/Wankhede-Stadium%2C-Mumbai-1.jpg',
    ],
  },
  {
    title: 'Mumbai Airport Terminal 1B',
    desc: 'ZINGA applications done for Mumbai Airport Terminal 1B (Roof Trusses). ZINGA applied as a primer with PU Top coat.',
    imgs: [
      'https://static.wixstatic.com/media/4c89a3_3f602c9e317a49738008330991235a16~mv2.jpg/v1/fill/w_980,h_500,al_c,q_85,enc_avif,quality_auto/Mumbai-Airport.jpg',
    ],
  },
  {
    title: 'Municipal Corporation Mumbai — Water Pipeline',
    desc: 'ZINGA applications done for Demo trial at MCGM Water Pipelines at their Kapurbawdi Yard (Thane).',
    imgs: [
      'https://static.wixstatic.com/media/4c89a3_c04eecf6858a475ca52349e7a9a99645~mv2.jpg/v1/fill/w_400,h_370,al_c,q_80,enc_avif,quality_auto/MCGM-Water-Pipeline-Demo-Trial-1.jpg',
      'https://static.wixstatic.com/media/4c89a3_762b30247d3c431384d368017c5fe66c~mv2.jpg/v1/fill/w_400,h_370,al_c,q_80,enc_avif,quality_auto/MCGM-Water-Pipeline-Demo-Trial-3.jpg',
    ],
  },
];

const DownloadIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
    <polyline points="7 10 12 15 17 10"/>
    <line x1="12" y1="15" x2="12" y2="3"/>
  </svg>
);

const DocList = ({ items }) => (
  <ul className="res-doc-list">
    {items.map((item, i) => (
      <li key={i} className="res-doc-item">
        <span className="res-doc-title">{item.title}</span>
        <a
          href={item.url}
          target="_blank"
          rel="noopener noreferrer"
          className="res-download-btn"
        >
          <DownloadIcon /> Download
        </a>
      </li>
    ))}
  </ul>
);

const Resources = () => {
  const [activeTab, setActiveTab] = useState('bridges');
  const { resources } = useAppData();

  return (
    <div className="res-page">
      {/* Hero */}
      <div className="res-hero">
        <div className="res-hero-inner">
          <span className="res-eyebrow">Technical Documentation</span>
          <h1 className="res-hero-title">Zinga Resources</h1>
          <p className="res-hero-sub">
            Download technical case studies, application reports and project references from across the globe.
          </p>
        </div>
      </div>

      {/* Tabs */}
      <div className="res-submenu-bar">
        <div className="res-submenu-inner">
          {TABS.map(tab => (
            <button
              key={tab.id}
              className={`res-tab-btn${activeTab === tab.id ? ' active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {/* Content */}
      <div className="res-content">
        <div className="res-container">

          {activeTab === 'bridges' && (
            <>
              <h2 className="res-section-title">Bridge Project References</h2>
              <p className="res-section-lead">International bridge projects where ZINGA® was used for corrosion protection of structural steel. Click to download individual case study PDFs.</p>
              <DocList items={resources.bridges} />
            </>
          )}

          {activeTab === 'food' && (
            <>
              <h2 className="res-section-title">Food & Beverage Application References</h2>
              <p className="res-section-lead">ZINGA® is approved for contact with potable water and food-safe environments. Download project references below.</p>
              <DocList items={resources.food} />
            </>
          )}

          {activeTab === 'casestudy' && (
            <>
              <h2 className="res-section-title">Application Case Studies</h2>
              <p className="res-section-lead">Real-world Indian project references demonstrating ZINGA® performance across infrastructure, sports and civic applications.</p>
              <div className="res-case-grid">
                {CASE_STUDIES.map((cs, i) => (
                  <div className="res-case-card" key={i}>
                    <div className="res-case-imgs">
                      {cs.imgs.map((src, j) => (
                        <img key={j} src={src} alt={cs.title} className="res-case-img" loading="lazy" />
                      ))}
                    </div>
                    <div className="res-case-body">
                      <h3 className="res-case-title">{cs.title}</h3>
                      <p className="res-case-desc">{cs.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}

          {activeTab === 'railways' && (
            <>
              <h2 className="res-section-title">ZINGA on Railways</h2>
              <p className="res-section-lead">ZINGA® has been extensively tested and applied on railway infrastructure across India and globally. Download the full presentation below.</p>
              <div className="res-railways-card">
                <div className="res-railways-icon">
                  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#2878c4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="2" y="7" width="20" height="14" rx="2"/>
                    <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/>
                    <path d="M2 13h20"/>
                    <path d="M6 17h.01M18 17h.01"/>
                  </svg>
                </div>
                <div className="res-railways-body">
                  <h3>{resources.railways?.title || 'ZINGA on Railway Transport'}</h3>
                  <p>{resources.railways?.desc || 'Comprehensive presentation covering ZINGA® applications on Indian Railways, railway bridges, rolling stock and track infrastructure.'}</p>
                  <a
                    href={resources.railways?.url || 'https://www.zinga.johngalt.in/_files/ugd/4c89a3_3d648429d2514c35891b619f3a3b7565.pptx?dn=ZINGA%20on%20Railway%20Transport%20-PPT.EN.pptx'}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="res-download-btn-lg"
                  >
                    <DownloadIcon /> Download Presentation (PPTX)
                  </a>
                </div>
              </div>
            </>
          )}

        </div>
      </div>

      {/* CTA */}
      <div className="res-cta">
        <div className="res-container">
          <h2>Need a Specific Technical Document?</h2>
          <p>Contact our team for additional case studies, TDS sheets, or application reports.</p>
          <a href="/contact" className="res-cta-btn">Contact Us</a>
        </div>
      </div>
    </div>
  );
};

export default Resources;
